import { ReviewAreaAction } from '../../../actions/review/review_area_action';
import { FeedBackModel } from '../../../models/review/review_js_env';
import { RootContainer } from '../../../root_container';
import { FeedbackArea } from './feedback_area';

export class FeedbackContainer extends RootContainer<FeedBackModel> {
  constructor(model: FeedBackModel, id: string) {
    super();
    super.mount(FeedbackArea, id);
    super.update(model);

    ReviewAreaAction.SEND_USEFULNESS.on((newModel) => id === newModel.id && this.update(newModel));
  }

  static init(model?: FeedBackModel) {
    return model ? new FeedbackContainer(model, model.id) : null;
  }
}
